<template>
  <div id="app">
    <div id="nav"></div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  created() {
    // 禁用浏览器自动保存滚动条位置
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual'
    }
    // this.platForm()
  },
  methods: {
    // platForm() {
    //   var u = navigator.userAgent
    //   if (!u.match(/AppleWebKit.*Mobile.*/) && process.env.NODE_ENV === 'production') {
    //     location.href = 'https://www.mcjdhjj.com/xianni/pc/dist/index.html'
    //   }
    // }
  }
}
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}
img {
  vertical-align: middle;
}

::-webkit-scrollbar {
  display: none;
}
body {
  position: relative;
  .van-toast--text {
    min-width: 26vw;
    padding: 2vw 6vw;
    font-size: 2.8vw;
  }
}
</style>
